import { render, staticRenderFns } from "./consultant.vue?vue&type=template&id=92bdd2bc&scoped=true&"
import script from "./consultant.vue?vue&type=script&lang=ts&"
export * from "./consultant.vue?vue&type=script&lang=ts&"
import style0 from "./consultant.vue?vue&type=style&index=0&id=92bdd2bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bdd2bc",
  null
  
)

export default component.exports